import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "sps-detail-container" }
const _hoisted_2 = {
  key: 0,
  class: "table-container"
}
const _hoisted_3 = { class: "product-info" }

import MarketTypeTab from '@/components/holdings/MarketTypeTab.vue'
import { computed, onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import { formatThousandsKeepDecimal } from '@/utils/num_format'
import useSps from '@/hooks/holdings/useSps'
import Decimal from 'decimal.js'
import TableEmpty from '@/components/holdings/TableEmpty.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'SpsDetail',
  setup(__props) {

const store = useStore()

const assetsInfo = computed(() => {
  const mv = store.state.holdings.spsPosPageList.totalMv.find(item => item.ccy === store.state.holdings.currencyActive.value)
  const mvValue = mv ? formatThousandsKeepDecimal(mv.value, 2) : '--'
  return [
    {
      label: `持仓净值(${store.state.holdings.currencyActive.name})`,
      value: mvValue
    }
  ]
})

const { querySpsData, loading } = useSps()

// 结构化票据列表
const spsPageList = computed(() => {
  const list = store.state.holdings.spsPosPageList.rows.filter(sps => {
    if (sps.sub_type === 'FCN') {
      const lifecycles = store.state.holdings.clientLifecycle.lifecycles.find(life => life.isin === sps.stockCode)
      if (lifecycles) {
        return true
      }
      return false
    }
    return true
  }).map(sps => {
    if (sps.sub_type === 'FCN') {
      const lifecycles = store.state.holdings.clientLifecycle.lifecycles.find(life => life.isin === sps.stockCode) || {}
      return {
        ...sps,
        couponRatio: formatCouponRatio(lifecycles?.couponRatio),
        sub_type: lifecycles?.productType,
        stockCode: lifecycles?.isin,
        investment_amount: formatInvestmentAmount(sps.marketValueDisplay) + sps.moneyType,
        underlying: lifecycles?.underlyingPerformance?.map(item => item.code).join('+')
      }
    }
    return {
      ...sps,
      investment_amount: formatInvestmentAmount(sps.marketValueDisplay) + sps.moneyType,
      couponRatio: sps.yield_to_maturity || '--',
    }
  })
  return list
})

const formatCouponRatio = (couponRatio: string = '') => {
  if (!couponRatio) return '--'
  return new Decimal(couponRatio).mul(100).toFixed(2, Decimal.ROUND_DOWN) + '%'
}

const formatInvestmentAmount = (investmentAmount: string) => {
  const amount = investmentAmount.replace(/,/g, '')
  return formatThousandsKeepDecimal(amount, 2)
}

onMounted(() => {
  querySpsData()
})


return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(MarketTypeTab, { assetsInfo: assetsInfo.value }, null, 8, ["assetsInfo"]),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "title" }, "持仓", -1)),
    (_unref(loading) || spsPageList.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            data: spsPageList.value,
            "show-overflow-tooltip": "",
            "header-cell-class-name": "sps-detail-table-header-cell",
            "row-class-name": "sps-detail-table-row",
            style: {"width":"100%"},
            "max-height": "300"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: "产品/ISIN",
                fixed: "",
                width: "300"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("span", null, _toDisplayString(scope.row.sub_type), 1),
                    _createElementVNode("span", null, _toDisplayString(scope.row.stockCode), 1)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "investment_amount",
                label: "市值"
              }),
              _createVNode(_component_el_table_column, {
                prop: "issuer",
                label: "发行商"
              }),
              _createVNode(_component_el_table_column, {
                prop: "underlying",
                label: "标的"
              }),
              _createVNode(_component_el_table_column, {
                prop: "couponRatio",
                label: "年化票息"
              }),
              _createVNode(_component_el_table_column, {
                prop: "maturity_date",
                label: "到期时间"
              })
            ]),
            _: 1
          }, 8, ["data"])), [
            [_directive_loading, _unref(loading)]
          ]),
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "tips" }, " 注：如阁下需交易结构化产品，请致电+852 2153 3366，与我们联络。 ", -1))
        ]))
      : _createCommentVNode("", true),
    (!_unref(loading) && !spsPageList.value.length)
      ? (_openBlock(), _createBlock(TableEmpty, { key: 1 }))
      : _createCommentVNode("", true)
  ]))
}
}

})